/*
As an admin of an organization/partner through Love Big, I want a way to control
the data in my organization in one spot, so that it's easier for me to find everything
I need.
*/

//Profile Dashboard --- multiple pages separated by tabs

//Packages
import React from "react";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";
//Components
import MobileNav from "../../components/MobileNav";
import ProfileNav from "../../components/ProfileNav";
import Footer from "../../components/Footer";
//Pages
import Edit from "./Edit";
import Projects from "./Projects";
import NewProject from "./NewProject";
import Account from "./Account";
import Users from "./Users";
import EditProject from "./EditProject";
//Material UI Components
import { Grid, Box } from "@mui/material";
//Animation
import { motion } from "framer-motion";

export default function Profile() {
  const location = useLocation();
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Grid
          container
          direction={{ xs: "column", md: "row" }}
          alignItems="stretch"
        >
          <Grid
            item
            display={{ xs: "none", md: "block" }}
            md={window.location.pathname !== "/profile/users" ? 5 : 2}
          >
            <ProfileNav></ProfileNav>
          </Grid>

          <Grid
            container
            item
            xs={12}
            md={window.location.pathname !== "/profile/users" ? 7 : 10}
            justifyContent="center"
          >
            {/* Nested router to display each page on the "profile dashboard" */}
            <Switch>
              <Route exact path="/profile/users">
                <Users></Users>
              </Route>
              <Route exact path="/profile/projects">
                <Projects></Projects>
              </Route>
              <Route exact path="/profile/projects/new">
                <NewProject></NewProject>
              </Route>
              <Route exact path="/profile/edit">
                <Edit></Edit>
              </Route>
              <Route exact path="/profile/editproject/:id">
                <EditProject></EditProject>
              </Route>
              <Route exact path="/profile/account">
                <Account></Account>
              </Route>
              {location.pathname === "/profile" ? (
                <>
                  <Redirect to="/profile/projects"></Redirect>
                </>
              ) : (
                <></>
              )}
            </Switch>
          </Grid>
          <Grid item xs={12} display={{ md: "none" }} pt="100px">
            <MobileNav></MobileNav>
          </Grid>
        </Grid>
        <Box display={{ xs: "none", md: "block" }}>
          <Footer></Footer>
        </Box>
      </motion.div>
    </>
  );
}
